import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './assets/style/index.styl'
import { VueAxios } from './utils/request'
import {
  Layout,
  Row,
  Col,
  Carousel,
  Button,
  Input,
  FormModel,
  Radio,
  Tooltip,
  Pagination,
  Empty,
  message,
  Select,
  Icon,
} from 'ant-design-vue'

Vue.use(Icon)
Vue.use(Select)
Vue.use(Layout)
Vue.use(Row)
Vue.use(Col)
Vue.use(Button)
Vue.use(Input)
Vue.use(Carousel)
Vue.use(FormModel)
Vue.use(Radio)
Vue.use(Tooltip)
Vue.use(Pagination)
Vue.use(Empty)
Vue.use(VueAxios)
Vue.prototype.$message = message
// IconPark
// Vue.user(Play)

Vue.config.productionTip = false

new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app')
